<template>
  <ol class="ranking-list">
    <li
      v-for="(content, rankingIndex) in dataRanking.team_ranking
        .company_contents"
      :key="rankingIndex"
      class="ranking-list__item"
    >
      <div v-if="content.rank === 1" class="rank">
        <img src="../../../../assets/images/ranking/1st-place.svg" alt="1" />
      </div>
      <div v-else-if="content.rank === 2" class="rank">
        <img src="../../../../assets/images/ranking/2nd-place.svg" alt="2" />
      </div>
      <div v-else-if="content.rank === 3" class="rank">
        <img src="../../../../assets/images/ranking/3rd-place.svg" alt="3" />
      </div>
      <div v-else class="rank">{{ content.rank }}</div>
      <div class="user-info">
        <div class="name">{{ content.company_name }}</div>
        <template
          v-for="(ranking_item, index) of dataEventSummary.ranking_items"
        >
          <div
            class="runner-num"
            v-if="ranking_item === Ranking.id.runner_num"
            :key="index"
          >
            {{ content.runner_num }}人参加
          </div>
          <div
            class="time"
            v-if="ranking_item === Ranking.id.time"
            :key="index"
          >
            {{ dataRanking.converted_time[rankingIndex] }}
          </div>
          <div
            class="distance"
            v-if="ranking_item === Ranking.id.distance"
            :key="index"
          >
            {{ dataRanking.converted_distance[rankingIndex] }}
          </div>
          <div
            class="completed-num"
            v-if="ranking_item === Ranking.id.completed_num"
            :key="index"
          >
            {{ content.completed_num }}人完走
          </div>
        </template>
      </div>
      <!-- 確定時 && (完走者1以上 || 規定距離なし) : 完走証へのリンク -->
      <router-link
        :to="{
          path: `/${langPath}${
            $route.path.includes('company') ? 'company/' : ''
          }ranking/certificate`,
          query: {
            event: nassEventId,
            team: content.company_id,
          },
        }"
        class="certificate flex-all-center"
        v-if="
          eventStatus === '100' &&
          ((content.completed_num &&
            'true' === content.is_over_required_finishers_number) ||
            (!dataEventSummary.summary.has_regulated_distance &&
              content.distance > 0))
        "
      >
        <figure class="certificate__figure">
          <img
            src="../../../../assets/images/certificate/certificate.svg"
            width="13"
            alt=""
          />
          <figcaption class="completion-fig">
            {{ Ranking.text.certificate[lang] }}
          </figcaption>
        </figure>
      </router-link>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    lang: String,
    langPath: String,
    Ranking: Object,
    dataEventRanking: Object,
    dataEventSummary: Object,
    dataRanking: Object,
    eventStatus: String,
    isForeignCountry: Boolean,
    nassEventId: String,
  },
  name: "TeamRankingList",
};
</script>

<style scoped lang="scss">
.ranking-list {
  .ranking-list__item {
    display: flex;
    padding: 15px 0;
    border-bottom: solid 1px var(--grayColor2);
    .rank {
      min-width: 40px;
      margin: 0 16px 0 0;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
    }
    .user-info {
      flex: 1;
      line-height: 1;
      margin: 0 24px 0 0;
      .name {
        margin: 6px 0 0 0;
        line-height: 1.2;
        font-size: 20px;
        font-weight: bold;
      }
      .runner-num,
      .time,
      .distance,
      .completed-num {
        margin: 5px 0 0 0;
        font-size: 14px;
      }
    }
    .certificate {
      width: 70px;
      height: 103px;
      font-size: 10px;
      border: solid 1px var(--defaultBlackColor);
      background-color: var(--defaultWhiteColor);
      &__figure {
        text-align: center;
        .completion-fig {
          margin: 7px 0 0 0;
        }
      }
    }
    .run-log {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 70px;
      height: 72px;
      background-color: var(--defaultGrayColor);
      &__dt {
        font-size: 12px;
        font-weight: normal;
      }
      &__dd {
        margin: 6px 0 0 0;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/company/ranking/TeamRankingList.vue